import { render, staticRenderFns } from "./FbComments.vue?vue&type=template&id=73adb070&scoped=true"
import script from "./FbComments.vue?vue&type=script&lang=js"
export * from "./FbComments.vue?vue&type=script&lang=js"
import style0 from "./FbComments.vue?vue&type=style&index=0&id=73adb070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73adb070",
  null
  
)

export default component.exports